module.exports = __webpack_public_path__ + "static/media/icons.64778bae.svg";